import axios from 'axios';
import { currentHttpOptions } from '../../../utils';

/**
 * @param {Date} date
 * @returns {Promise<ApiManager.GetLocationsResponse>}
 */
export const getLocations = (date) => axios.get(
    `${process.env.REACT_APP_API_DOTNET}/api/v1/Locations/GetLocations?date=${date}`,
    currentHttpOptions(),
);
